module.exports = __webpack_public_path__ + "img/advert.4b32716e.png";